import DealInviteApplicantsModalContainer from "./DealInviteApplicantsModalContainer";

export default DealInviteApplicantsModalContainer;
